/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZD0iTTQuMjY2NjcgMTVWMTEuMzcwNEgwVjFIMTZWMTEuMzcwNEg5LjI0OEw0LjI2NjY3IDE1Wk0xLjA2NjY3IDEwLjMzMzNINS4zMzMzM1YxMi45MjU5TDguODg1MzMgMTAuMzMzM0gxNC45MzMzVjIuMDM3MDRIMS4wNjY2N1YxMC4zMzMzWiIgZmlsbD0iaW5oZXJpdCIvPg==";